export default __webpack_public_path__ + "static/media/sithonia.bf628927.png";